// extracted by mini-css-extract-plugin
export default {"submit":"SaveCard_submit__gdxg5","submitButton":"SaveCard_submitButton__BIri5"};